/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bot: NonNullable<unknown> }} Leveling_Run_Subject_BoardInputs */



/**
* | output |
* | --- |
* | "{bot}'s leaderboard" |
*
* @param {Leveling_Run_Subject_BoardInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_run_subject_board = /** @type {((inputs: Leveling_Run_Subject_BoardInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Run_Subject_BoardInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Таблица лидеров ${i?.bot}`)
	return /** @type {LocalizedString} */ (`${i?.bot}'s leaderboard`)
});